import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { Profil, SharedDataService } from 'ngx-paf-common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'login-callback',
  templateUrl: './login-callback.component.html',
  styleUrls: ['./login-callback.component.scss']
})
export class LoginCallbackComponent implements OnInit {

  constructor(
    public sharedDataSvc:SharedDataService,
    private msalService: MsalService
  ) { }

  _localSub?: Subscription = null;

  ngOnInit(): void {
    if (!this.sharedDataSvc.profilLoaded || !!this.sharedDataSvc.profil){
      this._localSub = this.sharedDataSvc.loggedProfilChange.subscribe((p:Profil)=> {
        this.redirectToDefaultScreen(p);
    });
    } else {
      this.redirectToDefaultScreen(this.sharedDataSvc.profil);
    }
    
  }

  redirectToDefaultScreen(p:Profil):void{
    if (!!p) {
      if (this._localSub) {
        this._localSub.unsubscribe();
        this._localSub = null;
      }
      this.sharedDataSvc.redirectToDefaultScreen();
    }
  }
 

}
